import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {
    Box,
    CircularProgress,
    IconButton,
    InputAdornment, makeStyles,
    MenuItem,
    OutlinedInput,
    Typography
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import {useStores} from "../../../hooks/use-stores";
import {useTranslation} from "react-i18next";


const useStyles = makeStyles({
    popup: {

        position: "absolute",
        maxHeight: "300px",
        overflowY: "scroll",
        boxShadow:"2px 2px 10px 1px rgba(49, 49, 49, 0.5)",
        background: "#525252",
        margin: 0,
        padding: 0,
        width: "100%",
        zIndex: 1
    },
    plain: {
        margin: 0,
        padding: 0
    }
});


function UplineSearch({
                          handleUserSelectFromSearch,
                          show,
                          onlyId = true,
                          enableUplineSearch,
                          downlineCustomer,
                          noPadding,
                          disabled = false,
                          popup = false
                      }) {
    const {t} = useTranslation("teams");
    const classes = useStyles();
    const [searchValue, setSearchValue] = React.useState("");
    const [valueSelected, setValueSelected] = React.useState(false);

    const {myTeamsStore} = useStores();

    const {searching, searchResults} = myTeamsStore
    useEffect(() => {
        if (!show)
            setSearchValue("")
    }, [show]);

    useEffect(() => {
        return () => {
            myTeamsStore.clearSearchResults();
        }
    },[])


    const handleSearchStart = () => {
        if (enableUplineSearch) {
            myTeamsStore.searchUsersIncludingUpline(searchValue, downlineCustomer);
        } else {
            myTeamsStore.searchUsers(searchValue);
        }
        setValueSelected(false);

    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };


    const handleKey = (e) => {
        if (e.key === 'Enter') {
            if (searchValue)
                handleSearchStart()
        }
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleUserSelect = (searchResItem) => {
        handleUserSelectFromSearch(onlyId ? searchResItem.UserID : {
            ...searchResItem
            , userID: searchResItem.UserID
            , userName: `${searchResItem.FirstName} ${searchResItem.LastName}`
        })
        setSearchValue( `${searchResItem.FirstName} ${searchResItem.LastName}`)
        setValueSelected(true);
    }


    return <Box padding={noPadding ? 0 : 2} position={"relative"}>
        <OutlinedInput
            id="filled-adornment-password"
            type={'text'}
            value={searchValue}
            margin={"dense"}
            fullWidth
            disabled={disabled}
            autoFocus
            onChange={handleSearchChange}
            onKeyUp={e => handleKey(e)}
            placeholder={t("searchPlaceholder")}
            endAdornment={
                <InputAdornment position="end">
                    {searching
                        ? <CircularProgress size={20}/>
                        : <IconButton
                            disabled={searchValue === "" || searching}
                            aria-label="toggle password visibility"
                            onClick={handleSearchStart}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        ><SearchIcon/></IconButton>}
                </InputAdornment>
            }
        />
        {searching === false && searchResults.length === 0 &&
            <Typography>{t("notfound")}</Typography>}

        {!valueSelected &&  <ul className={popup ? classes.popup : classes.plain}>
            {searchResults.map((searchResItem) => (
                <MenuItem key={searchResItem.LOSUserID} onClick={() => {
                   handleUserSelect(searchResItem);
                }}>
                    {searchResItem.FirstName} {searchResItem.LastName}
                </MenuItem>))}
        </ul>}

    </Box>

}


export default observer(UplineSearch);